import { Labels } from '../types';

export const enLabels: Labels = {
  // Navigation & Header
  appTitle: 'AGENTDAGEN\'s News Agent',
  appSubtitle: 'Your simple AI agent to keep track of the most important news',
  profile: 'Profile',
  logout: 'Logout',
  backToChat: 'Back to Chat',
  mainAgent: 'AGENTDAGEN\'s News Agent',
  
  // Authentication
  login: 'Login',
  email: 'Email address',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  forgotPassword: 'Forgot password?',
  createAccount: 'Create account',
  alreadyHaveAccount: 'Already have an account? Login',
  backToLogin: 'Back to login',
  signUp: 'Sign Up',
  sendResetLink: 'Send Reset Link',
  
  // Common
  loading: 'Loading...',
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  back: 'Back',
  
  // Profile
  profileSettings: 'Profile Settings',
  profileSubtitle: 'Manage your account settings and preferences',
  personalInformation: 'Personal Information',
  displayName: 'Display Name',
  emailAddress: 'Email Address',
  emailCannotBeChanged: 'Email cannot be changed',
  updateProfile: 'Update Profile',
  deleteAccount: 'Delete Account',
  deleteAccountWarning: 'Once you delete your account, there is no going back. Please be certain.',
  deleteAccountConfirm: 'Delete Account',
  deleteAccountConfirmText: 'Are you sure you want to delete your account? This action cannot be undone.',
  dangerZone: 'Danger Zone',
  
  // Chat
  typeMessageHere: 'Type your message here...',
  processing: 'Processing your request...',
  suggestedSearches: 'Suggested searches:',
  searchSuggestion1: 'What are the latest trends in AI agents?',
  searchSuggestion2: 'Which companies in Europe are currently leading in AI agents?',
  searchSuggestion3: 'What do experts expect for trends in the field next year?',
  
  // Message Filters

  
  // Email Verification
  verifyEmailMessage: 'Please verify your email address. Check your inbox for a verification link.',
  
  // Messages
  resetPasswordMessage: 'If an account exists for this email, a password reset link has been sent.',
  sessionExpiredMessage: 'Your session has expired or you are not authenticated. Please log in again.',
  notAuthenticatedMessage: 'You are not authenticated.',
  verifyEmailAccessMessage: 'Please verify your email address to access this page.',
  
  // Language
  language: 'Language',
  english: 'English',
  danish: 'Danish',
  
  // Agent Role Names
  userRole: 'You',
  mainAgentRole: 'AGENTDAGEN\'s News Agent',
  planningAgentRole: 'Planning Agent',
  researchAgentRole: 'Research Agent',
  storageAgentRole: 'Storage Agent',
  agentRole: 'Agent',
  unknownAgent: 'Unknown',
  
  // Agent Status Messages
  analyzingRequest: 'Analyzing your request...',
  planningResearch: 'Planning research strategy...',
  conductingResearch: 'Conducting research...',
  storingQuery: 'Storing your search plan...',
  
  // Yes/No buttons
  yes: 'Yes',
  no: 'No',
  
  // Initialization message
  initializationMessage: 'Hello! Please introduce yourself and explain how you can help me today. My preferred language is English and today\'s date is {date}.',
  
  // Privacy
  privacyPolicy: 'Privacy Policy',
  privacyPolicySubtitle: 'How we collect, use, and protect your information',
  privacyPolicyTitle: 'Privacy Policy',
  privacyPolicyContent: 'This Privacy Policy describes how AGENTDAGEN\'s News Agent collects, uses, and protects your personal information when you use our service. By using our service, you agree to the collection and use of information in accordance with this policy.',
  dataCollectionTitle: 'Information We Collect',
  dataCollectionContent: 'We collect information you provide directly to us, such as your name, email address, and language preferences. We also collect information about your usage of our service, including your search queries and interactions with our AI agent.',
  dataUsageTitle: 'How We Use Your Information',
  dataUsageContent: 'We use the information we collect to provide, maintain, and improve our service, to communicate with you, and to personalize your experience. We may also use your information to develop new features and services.',
  dataProtectionTitle: 'Data Protection',
  dataProtectionContent: 'We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Your data is stored securely and we limit access to your personal information to authorized personnel only.',
  contactInfoTitle: 'Contact Information',
  contactInfoContent: 'If you have any questions about this Privacy Policy or our data practices, please contact us at privacy@agentdagen.com.',
  privacyAgreement: 'Privacy Agreement',
  privacyAgreementText: 'I agree to the',
  privacyAgreementLink: 'Privacy Policy',
}; 